import { ESharedFunction } from 'motw_core/Enums/ESharedFunction';
import * as React from 'react';
import { ShareState } from '../../../services/UI/State/ShareState';
import { TRenderable } from '../SharedTypes';
import { StyleClass } from '../Styles/CSS';

export function InCenterOfScreen() {
	const [ toRender, setToRender ] = React.useState<TRenderable>(<span />);

	const styleClass = StyleClass(`inCenterOfScreen`, {
		right: `50%`,
		bottom: `50%`,
		transform: `translate(50%, 50%)`,
		position: `fixed`,
		zIndex: 1
	});

	ShareState(ESharedFunction.InCenterOfScreen_toRender, toRender, setToRender);

	return (
		<div id="inCenterOfScreen" className={styleClass}>
			{toRender}
		</div>
	);
}
